


export function formatearMoneda(valor, paisODivisa = "CO") {
  try {
    const x = (paisODivisa || "CO").toString().trim().toUpperCase();

    const mapaPais = {
      CO: { locale: "es-CO", currency: "COP", maxDigits: 0 },
      MX: { locale: "es-MX", currency: "MXN", maxDigits: 0 },
      US: { locale: "en-US", currency: "USD", maxDigits: 2 },
      ES: { locale: "es-ES", currency: "EUR", maxDigits: 2 },
      AR: { locale: "es-AR", currency: "ARS", maxDigits: 0 },
      CL: { locale: "es-CL", currency: "CLP", maxDigits: 0 },
      PE: { locale: "es-PE", currency: "PEN", maxDigits: 2 },
    };

    const mapaDivisa = {
      COP: mapaPais.CO,
      MXN: mapaPais.MX,
      USD: mapaPais.US,
      EUR: mapaPais.ES,
      ARS: mapaPais.AR,
      CLP: mapaPais.CL,
      PEN: mapaPais.PE,
    };

    const mapaNombrePais = {
      COLOMBIA: "CO",
      MEXICO: "MX",
      MÉXICO: "MX",
      ESTADOSUNIDOS: "US",
      "ESTADOS UNIDOS": "US",
      ESPAÑA: "ES",
      ESPANA: "ES",
      ARGENTINA: "AR",
      CHILE: "CL",
      PERU: "PE",
      PERÚ: "PE",
    };

    // Decide cfg:
    let cfg =
      mapaDivisa[x] ||
      mapaPais[x] ||
      mapaPais[mapaNombrePais[x]] ||
      mapaPais.CO;

    let n = valor;
    if (typeof n === "string") n = Number(n.replace(/[^0-9.-]/g, ""));
    if (!Number.isFinite(n)) return "";

    return new Intl.NumberFormat(cfg.locale, {
      style: "currency",
      currency: cfg.currency,
      maximumFractionDigits: cfg.maxDigits,
    }).format(n);
  } catch {
    return `$${valor}`;
  }
}

